export const CONTENT_FORMATS = {
    AUDIO: 1,
    VIDEO: 2,
    LINK: 3,
    PDF: 4,
    DEEP_LINK: 5,
}